import {
  MantineProvider,
  v8CssVariablesResolver,
  type MantineProviderProps,
} from '@mantine/core';
import type { ReactNode } from 'react';
import { mantineTheme } from './mantine-theme';

export const orionMantineTestProviderProps: Pick<
  MantineProviderProps,
  'withCssVariables'
> = {
  withCssVariables: false,
};

export const OrionMantineProvider = ({
  children,
  theme = mantineTheme,
  cssVariablesResolver = v8CssVariablesResolver,
  ...props
}: MantineProviderProps & { children: ReactNode }) => (
  <MantineProvider
    theme={theme}
    cssVariablesResolver={cssVariablesResolver}
    {...props}
  >
    {children}
  </MantineProvider>
);
